/**
 * @name main.js
 */
// library
import { Ua } from './webgl/modules/Ua';
import TextureLoader from './webgl/modules/TextureLoader';
import { App as Webgl } from './webgl/app';

// mode
window.MODE = process.env.NODE_ENV === "development";
window.MODE = false;

// libs
window.UA = new Ua();

// TEXTURE
window.TEXTURE = [];

/**
 * @name App
 * @description アプリケーション全体の設定
 */
class App {
	constructor() {
		this.html = document.querySelector('html');
		this.world = document.querySelector('#world');
		this.textureLoader = new TextureLoader();
	}

	/**
	 * @name __loadTexture
	 * @description Textureの読み込み, ページ内にある[data-texture]を取得して読み込む
	 */
	async __loadTexture() {
		let dataTexture = document.querySelectorAll('[data-texture]');
		for (let el of dataTexture) {
			let src = el.getAttribute('data-texture');
			let texture = await this.textureLoader.__loader(src);
			window.TEXTURE.push(texture);
			el.remove();
		};
	}

	/**
	 * @name __init
	 * @description レンダリング
	 */
	async __init() {
		
		if (this.world) {
			await this.__loadTexture();
			await Webgl(this.world);
		}

		////////////////////////////////////////////////////////////////////////////////////////
		// webglの開発モード
		if (MODE) {
			console.log("~~ DEVELOPMENT MODE ~~");
			this.html.dataset.state = 'debug';
			this.world.classList.add('debug');

			// デバッグ用
			const debugInfo = document.createElement('div');
			debugInfo.style.cssText = `
				position: fixed;
				top: 0;
				right: 0;
				background: rgba(0, 0, 0, 0.5);
				color: #fff;
				z-index: 10000;
				`;
			debugInfo.innerHTML = `
				<p>ブラウザ: ${window.UA.data.browser}</p>
				<p>OS: ${window.UA.data.os}</p>
				<p>デバイス: ${window.UA.data.device}</p>
				<p>iPhone: ${window.UA.data.iphone}</p>
				<p>ドライバー: ${window.UA.data.driver}</p>
				<p>ドライバースペック: ${window.UA.data.driverSpec}</p>
				<p>CPU: ${window.UA.data.cpu}</p>
			`;
			document.body.appendChild(debugInfo);
		}
		////////////////////////////////////////////////////////////////////////////////////////
	}
}

App = new App();
App.__init();